<div class="breadcrumb_outer">
    <ul class="breadcrumb">
        <li>
            <a>{{ company_name }}:</a>
        </li>
        <li class="active" *ngFor="let item of breadcrumbsArray; let i = index">
            <a (click)="goToPageLink(item.page_ref)">
                {{ item.page_title }}
            </a>
        </li>
    </ul>
    <div class="right">
        <span>{{ today }}</span>
    </div>

    <div class="tag_powered_by">
        <span>Powered by: <b>Enertics</b></span>
    </div>
</div>

<div class="Content_outer">
    <div style="display: flex; align-items: center; justify-content: space-between">
        <h3 style="margin: 10px">All Trends</h3>
      
        <button type="button" class="btn default_btn"  (click)="goToBackToDashboard()">Back to Dashboard</button>
        
    </div>
    <div class="no_device" *ngIf="false">
        <p style="color: #838383; padding: 90px">{{ showEmptyError }}</p>
    </div>
    <div class="grid-container oven_additional_paramteres" style="margin-top: 11px">
        <button class="grid-item for_margin" *ngFor="let parameter of oven_params_list" style="cursor: pointer"
            [disabled]="chartloader" [style.background]="parameter.loader ? 'white' : parameter.color"
            (click)="getChartParameters(parameter.metric_key)">
            <span class="heading" *ngIf="!parameter.loader">{{
                parameter.metric_label
                }}</span>
            <span *ngIf="!parameter.loader; else spinner">{{ parameter.metric_group==null?parameter.value==0?'OFF':'ON':parameter.value }}</span>
            <ng-template #spinner>
                <div class="spinner-container charts-loader">
                    <div style="
              width: 2.3rem !important;
              height: 2.3rem !important;
              color: blue !important;
            " class="spinner-border" role="status"></div>
                </div>
            </ng-template>
        </button>
    </div>
    <div class="spinner-container" *ngIf="false" style="
      width: 100vw;
      height: 100vh;
      position: absolute;
      top: 0;
      left: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 10000;
    ">
        <!-- <div class="spinner-border text-primary" role="status"></div> -->
    </div>
    <app-oven-chart-modal [subsystem_id]='params.subsystemId' [client_id]="params.clientId"
        [parameter]="curr_parameter" (close_modal)="closeModal()" *ngIf="openModal"/>
</div>